import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import isoWeek from "dayjs/plugin/isoWeek";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { getMeasureDefinition } from "../config/sensors.config";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);
dayjs.extend(isSameOrBefore);

export const formatXAxis = (timestamp) => {
  return dayjs.utc(timestamp).format("DD/MM - HH:mm");
};

export const filteredDataFromDays = (selectedButton, data) => {
  const now = dayjs().tz("Europe/Rome");

  let rangeStart;
  if (selectedButton === "24h") {
    rangeStart = now.subtract(24, "hour");
  } else {
    rangeStart = now.subtract(7, "day");
  }

  const filteredData = data.filter((item) => {
    const itemDate = dayjs(item.timestamp);
    return itemDate.isAfter(rangeStart) && itemDate.isSameOrBefore(now);
  });
  return filteredData;
};

export const convertWeatherData = (weatherApiData) => {
  const chartData = [];

  weatherApiData?.forEach((day) => {
    day.hour.forEach((hourData) => {
      const timestamp = hourData.time.replace(" ", "T") + ":00Z";

      const chartEntry = {
        timestamp: timestamp,
        temperature: {
          value: hourData.temp_c,
          unit: "°C",
        },
        humidity: {
          value: hourData.humidity,
          unit: "%",
        },
        rainfall: {
          value: hourData.precip_mm,
          unit: "mm",
        },
      };

      chartData.push(chartEntry);
    });
  });

  return chartData;
};

export function getMeasureParameters(sensors) {
  const parameters = new Map();
  (Array.isArray(sensors) ? sensors : []).forEach((sensor) => {
    (sensor?.sensor_type?.measured_parameters || []).forEach((param) => {
      if (!parameters.has(param)) {
        const { label, unit } = getMeasureDefinition(param, sensor);
        parameters.set(param, { param, value: param, label, unit });
      }
    });
  });
  return Array.from(parameters.values());
}
